module.exports = __webpack_public_path__ + "img/4.8e592932.png";